import { render, staticRenderFns } from "./AddTransactionModal.vue?vue&type=template&id=825e703e&scoped=true&"
import script from "./AddTransactionModal.vue?vue&type=script&lang=js&"
export * from "./AddTransactionModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTransactionModal.vue?vue&type=style&index=0&id=825e703e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825e703e",
  null
  
)

export default component.exports